/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetCmsDetailContent Input Action
 */
export class GetCmsDetailContentInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsDetailContentData {
    id: string;
    type: string;
    title: string;
    content: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsDetailContentInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCmsDetailContentInput, ctx: Msdyn365.IActionContext): Promise<IGetCmsDetailContentData | null> {
    let pageID: string = '';
    let customerAccountNumber: string = '';
    if (ctx && ctx.requestContext && ctx.requestContext.query && ctx.requestContext.query.p) {
        pageID = ctx.requestContext.query.p;
    }
    if (ctx && ctx.requestContext && ctx.requestContext.user && ctx.requestContext.user.customerAccountNumber) {
        customerAccountNumber = ctx.requestContext.user.customerAccountNumber;
    }
    if (pageID !== '' || customerAccountNumber !== '') {
        if (customerAccountNumber === '') {
            customerAccountNumber = 'abcd';
        }
        // const frontApiEndpoint = 'http://herbal-cms.localhost:8001';
        const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
        const requestUrl = `${frontApiEndpoint}/api/detail/node--${pageID}/${customerAccountNumber}/en`;
        // const requestUrl = `${frontApiEndpoint}/api/detail/node--${pageID}/en`;

        const result = await Msdyn365.sendRequest<IGetCmsDetailContentData>(requestUrl, 'get')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                ctx.trace('[GetCmsDetailContentInput] Failed to get cms detail.');
                throw error;
            });
        return result;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsDetailContentData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsDetailContent',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
